<template>
  <div class="switch">
    <a-switch
      :checked="value"
      :disabled="disabled"
      @change="onChange"
    />
    <span
      class="switch_text"
      v-text="switchText"
    />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    switchText () {
      return this.value ? this.$t('message["1466"]') : this.$t('message["1459"]')
    }
  },
  methods: {
    onChange (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped lang="scss">
  .switch {
    display: inline-block;
    .switch_text {
      vertical-align: middle;
      margin-left: 8px
    }
  }
</style>
